document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".platesaver-cost-savings-calculator")) {
        import(/* webpackChunkName: "platesaver" */ "/Features/Calculators/PlatesaverCostSavingsCalculator/platesaver.js").then(async (module) => {
            const platesaver = new module.default();
            await platesaver.init();
        });
    }
});
